export default __webpack_public_path__ + "static/media/exit-full-screen.955efe7a.svg";